// extracted by mini-css-extract-plugin
export var address = "blog-store-module--address--b733d";
export var directs = "blog-store-module--directs--f409b";
export var features = "blog-store-module--features--3b05d";
export var hours = "blog-store-module--hours--9a750";
export var icon = "blog-store-module--icon--52018";
export var phone = "blog-store-module--phone--1e0ad";
export var store = "blog-store-module--store--4d2f3";
export var store_info = "blog-store-module--store_info--c2a48";
export var store_title = "blog-store-module--store_title--7da54";